import { useEffect } from 'react';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { DropDownButton, IconName, Stack } from '@optimus-web/core';
import { useCurrentUser } from '@mews-commander/core';
import { ModalSidePanel } from '@mews-commander/ui';
import { DeletePlatformProfileButton } from './DeletePlatformProfile';
import { PlatformProfileDetailsContent } from './PlatformProfileDetailsContent';
import { ResetAuthenticatorPlatformProfileButton } from './ResetAuthenticatorPlatformProfile/ResetAuthenticatorPlatformProfileButton';

export const PlatformProfileDetails = ({
    platformProfileId,
    closeDetails,
}: {
    platformProfileId: string;
    closeDetails: () => void;
}) => {
    const { data, isLoading, isError } = useRepositoryQuery('platformProfiles', 'get', {
        platformProfileId,
    });

    const { id: currentUserId } = useCurrentUser();
    const isOwnProfile = data?.userId === currentUserId;

    useEffect(() => {
        if (isError) {
            closeDetails();
        }
    }, [isError, closeDetails]);
    return (
        <>
            <ModalSidePanel
                opened
                onClose={closeDetails}
                headerActions={
                    data &&
                    !isOwnProfile && (
                        <Stack distribution="space-between" spacing="100">
                            <DeletePlatformProfileButton disabled={isLoading} data={data} />
                            {data.twoFactorAuthenticationEnabled && (
                                <DropDownButton icon={IconName.More} variant="tertiary" size="medium">
                                    <ResetAuthenticatorPlatformProfileButton disabled={isLoading} data={data} />
                                </DropDownButton>
                            )}
                        </Stack>
                    )
                }
                title={data?.fullName}
                width="medium"
                content={
                    data && (
                        <PlatformProfileDetailsContent
                            platformProfile={data}
                            isLoading={isLoading}
                            isOwnProfile={isOwnProfile}
                        />
                    )
                }
                loading={isLoading}
            />
        </>
    );
};
